(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colour-swatches"] && !Shopify.designMode) return;
  try {
    (function() {
  function init() {
    document.querySelectorAll('.colour-swatches-block').forEach(function(container) {
      container.querySelectorAll('.csb-dot, .csb-img-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectColour(btn.getAttribute('data-colour'), container);
        });
      });
    });
  }

  function selectColour(name, container) {
    var sel = document.querySelector('select[id*="Colour"], select[id*="Color"], select[name*="Colour"], select[name*="Color"]');
    if (sel) {
      sel.value = name;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var radios = document.querySelectorAll('input[type="radio"][name*="Colour"], input[type="radio"][name*="Color"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === name) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
    updateActive(container, name);
  }

  function updateActive(container, name) {
    container.querySelectorAll('.csb-dot, .csb-img-btn').forEach(function(b) {
      var on = b.getAttribute('data-colour') === name;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var el = container.querySelector('.csb-selected-name');
    if (el) el.textContent = name;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
